<div class="col-lg-12 ml-2 data-sect">

    <h3>Digital Factsheet List</h3>

    <table
        class="table"
        [svData]="data"
        #sv="svDataTable"
        [svRowsOnPage]="pageSize"
        *ngIf="data && data.length > 0"
    >
        <thead>
            <tr>
                <th>Title</th>
                <th class="text-center"> URL</th>
                <th class="text-center">Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of sv.data">
                <td
                    [display]="item.digitalFactsheetTitle"
                    [tooltip]="item.digitalFactsheetTitle"
                    placement="top"
                    show-delay="300"
                    class=""
                >
                    {{ item.digitalFactsheetTitle }}
                </td>

                <td
                    [display]="item.digitalFactsheetUrl"
                    [tooltip]="item.digitalFactsheetUrl"
                    placement="top"
                    show-delay="300"
                    class="text-center"
                >
                    {{ item.digitalFactsheetUrl }}
                </td>
                <td class="text-center">
                    <img src="assets/icons/delete_icon.png"  class="cursor-pointer" (click)="onDelete(item)">
                </td>
            </tr>
        </tbody>
        <tfoot *ngIf="data?.length > pageSize">
            <tr>
                <td
                    colspan="5"
                    class="center-paginator"
                >
                    <sv-bootstrap-paginator></sv-bootstrap-paginator>
                </td>
            </tr>
        </tfoot>
    </table>

    <div *ngIf="data?.length <= 0">
        <p class="no-data">No data found</p>
    </div>

</div>
